import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    ElementRef,
    HostListener,
    ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as JSZip from 'jszip';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { OGPATHS } from 'src-befor/app-routing.module';
import { Favorite } from 'src-ironside/repositories/favorite.repository';
import { Product, ProductExtendInfo } from 'src-ironside/repositories/product.repository';
import { getSafeFilename } from 'src-ironside/utils/dowload-file-zip';
import { ConfirmDialogData } from 'src/app/shared/components/dialogs/dialog-data';
import { AlertService } from 'src/app/shared/services/alert-service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { RouterService } from 'src/app/shared/services/router.service';
import { environment } from 'src/environments/environment.ironside';

@Component({
    selector: 'app-external-download',
    templateUrl: './external-download.component.html',
    styleUrls: ['./external-download.component.css'],
})
export class ExternalDownloadComponent implements OnInit {
    searchTerm = '';
    private searchTerm$ = new Subject<string>();
    productExtendInfo?: ProductExtendInfo[];
    selectedInfo: ProductExtendInfo;
    loading: boolean = false;
    isOnlyoneResource: boolean = false;
    visible: boolean = false;
    autocompleteList: any[] = [];
    fileSelected: any = {
        url: '',
        type: '',
        fileName: '',
        origin: null,
    };
    listIsDisabled = false;
    id: string;
    listImage?: string[];
    selected: boolean;
    imgShow?: string;

    selectedImage?: string;
    currentProduct?: Product;
    favorites: Favorite[];
    destroyRef = new Subject();
    defaultImg = 'src-ironside/assets/images/image-default.jpg';
    photo: any = [];
    video: [];
    loadingFile: boolean = false;
    pdfLoaded: boolean = false;
    documents: any[];
    downladeableDocs: any[];
    idProduct: string;
    responsiveOptions: any[];
    orientation: string = 'vertical';
    displayDetail = false;
    showDialog = false;
    indexLoading: number;
    @Output() result = new EventEmitter<any>();

    @ViewChild('searchContainer') searchContainer: ElementRef;

    constructor(
        private dynamicDocumentService: DynamicDocumentService,
        private elRef: ElementRef,
        private router: Router,
        private routerService: RouterService,
        private sanitizer: DomSanitizer,
        private alertService: AlertService
    ) {
        this.setSearchPipe();
    }

    ngOnInit(): void {
        this.responsiveOptions = [
            {
                breakpoint: '1024px',
                numVisible: 3,
                numScroll: 1,
            },
            {
                breakpoint: '767px',
                numVisible: 2,
                numScroll: 1,
            },
            {
                breakpoint: '560px',
                numVisible: 1,
                numScroll: 1,
            },
        ];
    }
    private isIronside(): boolean {
        return environment.client === 'ironside';
    }

    downloadFile(fileUrl: string, filename: string, resource?: any) {
        if (resource.availableOnTheDownloadPage === false) {
            alert('This resource is not available for download.');
            return;
        }
        if (!fileUrl) return;
        this.loading = true;

        if (
            this.isIronside() &&
            this.productExtendInfo &&
            this.productExtendInfo[0] &&
            this.productExtendInfo[0].url &&
            this.productExtendInfo[0].url[0]
        ) {
            const info = this.productExtendInfo[0].url[0];

            const currentLang = localStorage.getItem('lang') ?? 'en';
            const locale =
                environment?.languagesExtranet?.find((l: any) => l.code == currentLang)?.locale ??
                'en_GB';

            let prefix: string = '';
            if (info.linkToProduct && info.linkToProduct.length > 0) {
                prefix += info.linkToProduct[0].value;
            }
            if (info.linkToPartner && info.linkToPartner.length > 0) {
                prefix += info.linkToPartner[0].value;
            }
            if (info.linkToSupplier && info.linkToSupplier.length > 0) {
                prefix += info.linkToSupplier[0].value;
            }
            if (info.typeOfResource) {
                try {
                    prefix += `-${info.typeOfResource.labels[locale]}`;
                } catch (e) { }
            }
            const extension: string = filename.substring(filename.lastIndexOf('.'));
            filename = `${prefix}${extension}`;
        }
        /* filename = decodeURIComponent(filename).toUpperCase().replace(/ /g, '-');
    filename = filename.replace(/["'&=$€*\/+\[\]{}|]/g, '-');
    const fileExtension = this.getFileExtensionFromUrl(fileUrl);
    const filenameResult = `${filename}.${fileExtension}`; */

        const title = resource?.file[0]?.url?.title;
        const fileNames = getSafeFilename(
            title || 'file',
            resource?.file[0]?.url,
            resource?.typeOfResource.value,
            resource?.title
        );
        fetch(fileUrl)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.blob();
            })
            .then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);

                const anchor = document.createElement('a');
                anchor.href = blobUrl;
                anchor.download = fileNames;
                anchor.click();
                this.loading = false;

                window.URL.revokeObjectURL(blobUrl);
            })
            .catch((error) => {
                this.loading = false;
                console.error('Error downloading file:', error);
            });
    }

    downloadAllResource() {
        const resources = this.currentProduct?.resources || [];

        if (resources.length === 0) return;
        if (resources?.length > 1) {
            this.loading = true;
            const zip = new JSZip();
            const filePromises: Promise<void>[] = [];
            const filteredResources = resources.filter((res: any) => {
                const type = res.typeOfResource?.value;
                return type === 'PI_MAN' || type === 'TI_CER_IR';
            });

            filteredResources?.forEach((resource: any) => {
                if (resource?.availableOnTheDownloadPage === false) {
                    return;
                }
                resource?.file?.forEach((file: any) => {
                    const fileUrl = file?.url;
                    const typeOfResource = resource?.typeOfResource;
                    const referential = resource?.referential;

                    const filename = getSafeFilename(
                        fileUrl?.title || 'file',
                        fileUrl,
                        typeOfResource.value,
                        resource.title
                    );

                    const filePromise = fetch(fileUrl)
                        .then((response) => {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            return response.blob();
                        })
                        .then((blob) => {
                            zip.file(filename, blob);
                        })
                        .catch((error) => console.error('Error downloading file:', error));

                    filePromises.push(filePromise);
                });
            });

            Promise.all(filePromises).then(() => {
                zip.generateAsync({ type: 'blob' }).then((zipBlob: Blob) => {
                    const zipUrl = URL.createObjectURL(zipBlob);
                    const a = document.createElement('a');
                    a.href = zipUrl;
                    a.download = 'download.zip';
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(zipUrl);
                    this.loading = false;
                });
            });
        } else {
            this.loading = false;
            this.downloadFile(
                this.documents?.[0]?.files?.[0]?.url,
                this.documents?.[0]?.title ?? '',
                this.documents?.[0]
            );
        }
    }
    getFileExtensionFromUrl(url: string) {
        try {
            const pathname = new URL(url).pathname;
            const filename = pathname.split('/').pop();
            const extension = filename?.split('.').pop();

            return extension?.includes('?') ? extension.split('?')[0] : extension;
        } catch (error) {
            console.error('Invalid URL:', error);
            return '';
        }
    }

    onShowFile(resource: any) {
        if (resource?.availableOnTheDownloadPage === false) {
            let dialog: ConfirmDialogData = {
                title: '',
                message: 'This resource is not available for download.',
            };

            dialog.isAlert = true;
            this.alertService.confirmDialog(dialog).subscribe();
            return;
        }
        const url = resource?.file?.[0]?.url;
        const fileExtension = this.getFileExtensionFromUrl(url);
        if (fileExtension === 'pdf') {
            this.loadingFile = true;
        }
        this.visible = true;
        this.fileSelected = {
            url: url,
            type: fileExtension ?? '',
            fileName: resource?.title,
            origin: resource,
        };

        setTimeout(() => {
            this.loadingFile = false;
        }, 3000);
    }
    setSearchPipe() {
        this.searchTerm$
            .pipe(debounceTime(300), distinctUntilChanged())
            .subscribe((searchTerm: string) => {
                if (searchTerm) {
                    this.autocomplete(searchTerm);
                } else {
                    this.autocompleteList = [];
                }
            });
    }

    showImage(img: string): void {
        this.imgShow = img;
        this.checkImageValid(img);
    }

    checkImageValid(url: string) {
        const img = new Image();
        img.src = url;

        img.onerror = () => {
            this.imgShow = this.defaultImg;
        };
    }
    sanitizedUrl(value: string) {
        const googleViewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
            value
        )}&embedded=true`;
        return this.sanitizer.bypassSecurityTrustResourceUrl(googleViewerUrl);
    }
    pageComplete(_event: any) {
        //this.pdfLoaded = false;
    }

    pageRendered(_event: any) {
        //this.pdfLoaded = false;
        this.loadingFile = false;
    }
    onImgError(event: Event) {
        const target = event.target as HTMLImageElement;
        target.src = this.defaultImg; // Đặt ảnh mặc định
    }

    goToFeatures() {
        const el = document.getElementById('features');
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
        }
    }

    public toggleSelected() {
        this.selected = !this.selected;
    }
    getTranslatedRoute(route?: string) {
        return this.routerService.getTranslatedRoute(route);
    }

    onSearchInput(): void {
        this.searchTerm$.next(this.searchTerm);
    }

    autocomplete(term: string) {
        if (term.length >= 3) {
            this.dynamicDocumentService
                .find(
                    {
                        collectionName: 'dynamic_product',
                        filters: [
                            {
                                fieldName: 'referenceProduct',
                                operator: 'OR',
                                conditions: [{ type: 'CONTAINS', value: term }],
                            },
                            {
                                fieldName: 'gencodeProduct',
                                operator: 'OR',
                                conditions: [{ type: 'CONTAINS', value: term }],
                            },
                            {
                                fieldName: 'statusProduct',
                                operator: 'AND',
                                conditions: [{ type: 'EQUALS', value: 'VALIDE' }],
                            },
                            {
                                fieldName: 'typeOfProduct',
                                conditions: [{ type: 'EQUALS', value: 'FILS' }],
                            },
                        ],
                        sorts: {},
                        page: 1,
                        pageSize: 5,
                    },
                    true
                )
                .subscribe((res: any) => {
                    this.autocompleteList = res.content;
                });
        }
    }

    disableList() {
        this.listIsDisabled = true;
        setTimeout(() => {
            this.listIsDisabled = false;
        }, 1000);
    }



    selectItem(item: any) {
        this.currentProduct = item;

        this.searchTerm = item.referenceProduct || item.nom;
        let resourceIds = item.linkToRessources?.map((resource: any) => resource.documentId) || [];
        this.dynamicDocumentService
            .findByIds('dynamic_ressource', resourceIds, true)
            .subscribe((res: any) => {
                if (res && res.length > 0) {
                    if (this.currentProduct) this.currentProduct.resources = res;
                    this.video = res.filter((r: any) => r.typeOfResource.value === 'VIDEO');
                    this.photo = res.filter((r: any) => r.typeOfResource.value === 'PHOTO');

                    this.documents = res.filter(
                        (doc: any) => doc.availableOnTheDownloadPage !== false
                    );

                    this.downladeableDocs = this.documents.filter((doc: any) => {
                        const type = doc.typeOfResource?.value;

                        return type === 'PI_MAN' || type === 'TI_CER_IR';
                    });
                    if (this.downladeableDocs && this.downladeableDocs.length == 1) {
                        this.isOnlyoneResource = true;
                    }
                }

                this.selectedImage = this.photo?.[0]?.file?.[0]?.url || this.defaultImg;
            });
        this.autocompleteList = [];
        this.displayDetail = true;

        setTimeout(() => {
            document
                .querySelector('.container-section-detail')
                ?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    }

    @HostListener('document:click', ['$event.target'])
    onClickOutsideDiv(targetElement: HTMLElement) {
        const clickedInside = this.elRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.autocompleteList = [];
        }
    }

    triggerClickEvent() {
        this.searchContainer.nativeElement.click();
    }
}
